import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cf9f3dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-strip" }

import {computed, ref, watch} from 'vue';

interface Props {
	buttonsPerRow: number;
	totalButtons: number;
	selectedItem?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonStrip',
  props: {
    buttonsPerRow: {},
    totalButtons: {},
    selectedItem: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "3f80983e": (_ctx.totalButtons),
  "54638e88": (col.value)
}))

const props = __props;
const activeItem = ref(0);

const col = computed(() => props.selectedItem % props.buttonsPerRow);

watch( props, ({ selectedItem } ) => {
	activeItem.value = selectedItem;
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})